/* eslint-disable vue/require-v-for-key */
<template>
  <div id="lista-cidades" class="lista-dicas">
    <h1 class="title text-uppercase font-weight-bold">Imagens das categorias do app</h1>
    <hr class="linha-amarela" />
    <table class="table">
      <thead class="letter-orange">
        <tr>
          <th>Imagem</th>
          <th>Nome</th>
          <th>Nome departamento pai</th>
          <th style="width:50px">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(img, index) in imagens" :key="index">
          <td>
            <img
              :src="`${getImagesAddressAppAws}` + img.imagem_departamento"
              alt="Imagem da categoria"
              class="imagenEdit"
            />
          </td>
          <td>{{ img.nome_departamento }}</td>
          <td>{{ img.nome_departamento_pai }}</td>
          <td>
            <b-button
              variant="primary"
              class="mr-1"
              @click="editImagem(img)"
            >
              <i class="fas fa-edit"></i>
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>

    <b-modal :title="'Editar imagem da categoria '+imagem.nome_departamento" size="lg" ref="modalEditarImagem" hide-footer>
      <div class="d-block">
        <div class="row">
          <div class="col-md-12">
            <label>Nome da imagem:</label>
            <input type="text" class="form-control" :value="imagem.imagem_departamento" readonly>
          </div>
          <div class="col-md-12 mt-2">
            <div class="text-center">
              <img :src="`${getImagesAddressAppAws}` + imagem.imagem_departamento" alt="Imagem da categoria" class="imagenEditModal"/>
            </div>
          </div>
          <div class="col-md-12 mt-2">
            <label>Nova imagem:</label>
            <input
              type="file"
              id="file"
              ref="file"
              class="form-control"
              lang="pt"
              accept="image/x-png"
            />
          </div>
          <div class="col-md-12 mt-4 text-center">
            <button class="btn btn-success" @click="uploadCategoria()">Editar imagem</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import makeToast from '../../../mixins/makeToast';

export default {
  name: 'EditCategoriaApp',
  mixins: [makeToast],
  data() {
    return {
      imagens: [],
      imagem: {},
      imageUp: ''
    };
  },
  computed: {
    ...mapGetters('general', ['getImagesAddressAppAws']),
  },
  created() {
    this.$store.dispatch('startLoader');
    this.getCategorias();
  },
  methods: {
    ...mapActions('imagem', ['listCategorias', 'save']),
    getCategorias() {
      this.listCategorias()
        .then((response) => {
          this.imagens = response.data;
        })
        .catch((error) => {
          this.makeToast('Oopss!', 'Erro ao buscar imagens das categorias', 'danger');
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    update(msg) {
      this.save(this.imagem)
        .then((response) => {
          if(response.data == true) {
            this.makeToast('Sucesso!', msg, 'success');
          } else {
            this.makeToast('Oopss!', 'Erro ao salvar a imagem da categoria', 'danger');
          }
        })
        .catch((error) => {
          this.makeToast('Oopss!', 'Erro ao salvar a imagem da categoria', 'danger');
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    editImagem(img) {
      this.imagem = img;
      this.$refs.modalEditarImagem.show();
    },
    uploadCategoria() {
      // eslint-disable-next-line prefer-destructuring
      const formData = new FormData();
      this.imageUp = this.$refs.file.files[0];
      formData.append('file', this.imageUp);
      formData.append('imgDelete', this.imagem.imagem_departamento);

      this.$store.dispatch('startLoader');
      this.$store.dispatch('files/uploadFileApiAppCategoria', formData)
        .then((response) => {
          if(response.data.error == true) {
            this.$store.dispatch('endLoader');
            this.makeToast('Oops!', response.data.message, 'danger');
          } else {
            this.imagem.imagem_departamento = response.data.data;
            this.$refs.modalEditarImagem.hide();
            this.update(response.data.message);
          }
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast('Oops!', 'Não foi possível inserir sua imagem, tente novamente!', 'danger');
        })
    },
  },
};
</script>

<style scoped>
.imagenEdit {
  width: 50px;
  height: 50px;
}
.imagenEditModal {
  max-width: 350px;
  text-align: center;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
    content: 'Browse';
}

.custom-file-input:lang(pt) ~ .custom-file-label::after {
    content: 'Subir';
}
</style>
